module.exports = __webpack_public_path__ + "img/土拨鼠.3ce1b944.png";